import { SVGProps } from 'react';

function AddMoreImageIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.8333 16.3333C10.8333 16.9167 10.9417 17.475 11.125 18H4.16667C3.72464 18 3.30072 17.8244 2.98816 17.5118C2.67559 17.1993 2.5 16.7754 2.5 16.3333V4.66667C2.5 3.75 3.25 3 4.16667 3H15.8333C16.2754 3 16.6993 3.17559 17.0118 3.48816C17.3244 3.80072 17.5 4.22464 17.5 4.66667V11.625C16.975 11.4417 16.4167 11.3333 15.8333 11.3333V4.66667H4.16667V16.3333H10.8333ZM11.6333 10.7417L9.34167 13.6917L7.70833 11.725L5.41667 14.6667H11.125C11.4583 13.7333 12.0583 12.925 12.8333 12.3417L11.6333 10.7417ZM16.6667 15.5V13H15V15.5H12.5V17.1667H15V19.6667H16.6667V17.1667H19.1667V15.5H16.6667Z"
        fill="#7F38E9"
      />
    </svg>
  );
}

export default AddMoreImageIcon;
